<template>
  <div class="consult-container">
    <div class="search-container">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="服务商名称">
          <el-input v-model="formInline.serverName" placeholder="请输入服务商名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-container">
      <el-table v-loading="tableLoading" :data="tableData" :pagination="pagination" border style="width: 100%">
        <el-table-column label="序号" type="index" width="50" align="center">
          <template slot-scope="scope">
            <span>{{ (pagination.currentPage - 1) * pagination.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="memberName" label="用户" align="center">
        </el-table-column>
        <el-table-column prop="authDate" label="认证时间" align="center" :formatter="dateFormat">
        </el-table-column>
        <el-table-column prop="enterpriseName" align="center" label="企业名称">
        </el-table-column>
        <el-table-column prop="serverName" align="center" label="认证服务商名称">
        </el-table-column>
        <el-table-column prop="status" align="center" label="审核状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0">通过</span>
            <span v-else-if="scope.row.status === 1">未通过</span>
            <span v-else-if="scope.row.status === 2">待审核</span>
            <span v-else>未知状态</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
            <el-button v-if="scope.row.status === 2" type="text" size="small" class="mx-10"
              @click="handleReviewClick(scope.row)">审核</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
        </el-pagination>
      </div>
    </div>
    <!-- 审核功能 -->
    <el-drawer title="审核" :visible.sync="drawer" direction="rtl" :before-close="handleClose">
      <el-form ref="form" :model="drawerForm" label-width="80px">
        <el-form-item label="审核结果">
          <el-radio-group v-model="drawerForm.result">
            <el-radio :label="0">通过</el-radio>
            <el-radio :label="1">不通过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="原因" v-if="drawerForm.result === 1">
          <el-input type="textarea" placeholder="请输入原因" v-model="drawerForm.reason"></el-input>
        </el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button @click="cancelForm">取 消</el-button>
        <el-button type="primary" @click="submitReview" :loading="loading">{{ loading ? '提交中 ...' : '确 定' }}</el-button>
      </div>
    </el-drawer>
    <!-- 查看详情 -->
    <el-drawer title="查看详情" :visible.sync="detailDrawer" direction="rtl" :before-close="handleClose">
      <el-descriptions :column="1" :labelStyle="{ width: '120px', textAlign: 'right' }" :contentStyle="{ flex: 1 }">
        <el-descriptions-item v-for="(item, index) in detailCols" :span="item.span ? item.span : 1" :key="index"
          :label="item.label">{{ item.formatter ? item.formatter(record) : record[item.prop] }}</el-descriptions-item>
      </el-descriptions>
    </el-drawer>
  </div>
</template>

<script>
import { getList, getReview } from '@/api/certificationAudit'
import moment from 'moment'
export default {
  name: 'AdminStaticsService',
  data() {
    return {
      tableLoading: false,
      drawer: false,
      formInline: {
        serverName: '',
      },
      pagination: {
        currentPage: 1, // 当前页
        pageSize: 10, // 每页显示条数
        total: 0, // 总条数
        layout: 'total, prev, pager, next, jumper', // 分页布局
      },
      tableData: [],
      drawerForm: {
        result: 0,
        reason: '',
      },
      record: {},
      detailDrawer: false,
      detailCols: [
        {
          label: '用户',
          prop: 'memberName'
        },
        {
          label: '认证时间',
          prop: 'authDate',
          formatter: (row) => moment(row.authDate).format('YYYY-MM-DD HH:mm:ss'),
        },
        {
          label: '企业名称',
          prop: 'enterpriseName'
        },
        {
          label: '认证服务商名称',
          prop: 'serverName'
        },
      ]
    };
  },

  mounted() {
    this.loadData()
  },
  methods: {
    cancelForm() {
      this.drawer = false
    },
    // 时间转换
    dateFormat(row) {
      return moment(row.authDate).format('YYYY-MM-DD HH:mm:ss');
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadData()
    },
    handleClick(row) {
      this.detailDrawer = true
      this.record = row
    },
    handleReviewClick(row) {
      this.drawer = true
      this.record = row
    },
    async submitReview() {
      const params = {
        status: this.drawerForm.result
      }
      if (this.drawerForm.result === 1) {
        params.reason = this.drawerForm.reason
      }
      await getReview({
        authType: 'SERVER_AUTH',
        memberId: this.record.memberId,
        userAuthId: this.record.id,
        ...params
      }).then(() => {
        this.$message.success('审核成功')
        this.drawer = false
        this.record = {}
        this.loadData()
      })
    },
    onSubmit() {
      this.loadData()
    },
    async loadData() {
      this.tableLoading = true
      const params = {}
      if (this.formInline.serverName) {
        params.serverName = this.formInline.serverName
      }
      await getList({
        pageNo: this.pagination.currentPage - 1,
        pageSize: this.pagination.pageSize,
        ...params,
        authType: 2,
      }).then(res => {
        this.tableLoading = false
        this.tableData = res.data.content
        this.pagination.total = res.data.totalElements
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.consult-container {
  background: #fff;
  padding: 24px 0;

  .search-container {
    padding: 0 16px;
    border-bottom: 1px solid #EBEEF5;
  }

  .table-container {
    padding: 16px;
  }

  .pagination-container {
    margin-top: 16px;
    text-align: right;
  }

  .mx-10 {
    margin: 0 10px;
  }

  .drawer-footer {
    text-align: center;
  }
}

::v-deep .el-drawer__body {
  padding: 0 16px;
}
</style>